<!--
    This File shows the Parent details for a Seller
     That doesn't have a parent.
-->
<template>
  <div class="">
      <!-- Parent -->

      <br />
      <v-card>
       <v-card-title primary-title>
           <div>
             Your account does not have a parent assigned to review.
             You can add a parent account here to let your parent see and help with your account.
           </div>
       </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show"  flat color="accent">
           Add a parent
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>
          </v-btn>
       </v-card-actions>

       <v-slide-y-transition>
         <v-card-text v-show="show">
           <v-form width="100px" v-model="valid">

               <v-text-field
                 v-model="newEmail"
                 type="text"
                 :rules="emailRules"
                 label="New Email"
                 required
               ></v-text-field>
               <v-layout row align-center justify-center>
                 <v-btn class="success" @click.stop="submit"  :disabled="!valid" :loading="inprogress" >Submit</v-btn>
               </v-layout>
           </v-form>

           <v-layout row class="error--text" v-if="errMessage">
             <v-spacer></v-spacer>
             <span>{{ errMessage }}</span>
           </v-layout>
           <v-layout row class="heading success--text " v-if="success">
             <v-spacer></v-spacer>
             <span>Parent was successfully added to your account.</span>
           </v-layout>

         </v-card-text>
       </v-slide-y-transition>
      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import utils from '../../../utils.ts'
import config from '../../../config.js'

export default {
  name: 'ParentCardCreate',
  components: {
  },
  computed: {
    ...mapState({
    })

  },
  props: {

  },
  data () {
    return {
      show: false,
      valid: false,
      inprogress: false,
      errMessage: null,
      newEmail: null,
      success: false,
      emailRules: [
        utils.required('This field is required'),
        utils.emailValidation('Email is not valid')
      ]
    }
  },
  methods: {
    submit: async function () {
      // Update the password
      this.inprogress = true
      this.errMessage = null
      this.success = false

      // Call the async function to create a parent account (if needed) and
      // to assign that account to this Kid
      try {

        const func = config.getFunctions().httpsCallable('createParentForUser')
        await func({
          email: this.newEmail
        })
        this.success = true

        // Save the email locally so you don't need to ask the user for it again
        // if they open the link on the same device.
        window.localStorage.setItem('emailForSignIn', this.newEmail);

      } catch (err) {
        console.error('ERROR : ' + JSON.stringify(err))
        this.errMessage = err.message
      }

      this.inprogress = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
